export default __webpack_public_path__ + "static/media/casinoBG.4ef8b767.svg";